import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import routes from "./common/routes";
import common from "./common/common";
import store from "./common/store";
import { apis } from "@common/config";
import AppNotificationHandler from "./common/Notify";
import Toast from "@common/toast/toast";
import ToastConfirm from "@common/toastConfirm/toast";
import toastHtml from "@common/toastHtml/toast";
import Confirm from "@common/confirm/confirm";
import ConfirmTitle from "@common/confirmTitle/confirm";
import FullTitle from "@common/fullTitle/confirm";
import Loading from "@common/loading/loading";
import ImgLoading from "@common/imgLoading/loading";
import Ask from "@common/ask/ask";
import MaterialBox from "@common/materialBox/materialBox";
import MaterialListBox from "@common/materialListBox/materialListBox";
import MediaListBox from "@common/mediaListBox/materialListBox";
import Viewer from "@common/viewer/viewer";
import Pagetype from "@common/pageType/pageType";
import VoiceEditType from "@common/voiceEditType/voiceEditType";
import PicEditType from "@common/picEditType/picEditType";
import PicEditType1 from "@common/picEditType1/picEditType";
import Audit from "@common/audit/audit";
import Success from "@common/success/success";
import CloudEditConfirm from "@common/cloudEditConfirm/cloudEditConfirm";
import CloudEditConfirmStream from "@common/cloudEditConfirmStream/cloudEditConfirmStream";
import MiniPicture from "@common/miniPicture/miniPicture";
import Typo from "@common/typo/typo";
import Card from "@common/card/card";
import CardPos from "@common/cardPos/card";
import CardRight from "@common/cardRight/card";
import DownloadBtn from "@common/downloadBtn/download";
import DownloadMessage from "@common/download/download";
import NewDownloadMessage from "@common/newDownload/download";
import AiMessage from "@common/aiMessage/aiMessage";
import AiWriter from "@common/aiWriter/aiWriter";
import AiOptimizeWriter from "@common/aiOptimizeWriterDialog/aiOptimizeWriterDialog";
import RadioDownloadMessage from "@common/radioDownload/download";
import AudioDownloadMessage from "@common/audioDownload/download";
import FileSend from "@common/fileSend/download";
import chatGpt from "@common/chatGpt/download";
import Warning from "@common/warning/warning";
import KkType from "@common/kkType/kkType";
import Rename from "@common/rename/rename";
import LabelSelect from "@common/labelSelect/labelSelect";
import NewMaterialBox from "@common/newMaterialBox/newMaterialBox";
import componentsInstall from "@/components/componentsInstall";
import ShareCode from "@common/shareCode/shareCode";
import MediaPlatform from "@common/mediaPlatformConfirm/mediaPlatformConfirm";
import MediaPlatformPhoto from "@common/mediaPlatformPhoto/mediaPlatformPhoto";
import MediaPlatformShare from "@common/mediaPlatformShare/mediaPlatformShare";
import MediaPlatformNotify from "@common/mediaPlatformNotify/mediaPlatformNotify";
import MediaPlatformNotifyAuth from "@common/mediaPlatformNotifyAuth/mediaPlatformNotify";
import MediaPlatformManage from "@common/mediaPlatformManage/mediaPlatformManage";
import MediaPlatformTag from "@common/mediaPlatformTag/mediaPlatformTag";
import MediaPlatformAccount from "@common/mediaPlatformAccount/mediaPlatformAccount";
import PreviewBox from "@common/previewBox/previewBox";
import PreviewKnews from "@common/previewKnews/previewBox";
import EditorCard from "@common/editorCard/editorCard";
import BPlus from "@common/bPlus/bPlus";
import filterBox from "@common/filterBox/filterBox";
import Dialog from "@common/dialog/index";
import SelectDialog from "@common/selectDialog/index";
import Table from "@common/table/index";
import authTable from "@common/authTable/index";
import ArticlePreview from "@common/articlePreview/articlePreview";
import MediaPreview from "@common/mediaPreview/mediaPreview";
import MediaSort from "@common/mediaSort/mediaSort";
import InterviewCheck from "@common/interviewCheck";
import InterviewTable from "@common/interviewTable";
import UploadTable from "@common/uploadTable";
import ResourcesDetail from "@common/resourcesDetail";
import WaterEdit from "@common/waterEdit/waterEdit";
import TagInput from "@common/tagInput/index";
import VideoClip from "@common/videoClip/index";
import dyScan from "@common/dyScan/dyScan";
import tipsBox from "@common/tipsBox/tipsBox";
import MediaPlatformWater from "@common/mediaPlatformWater/mediaPlatformConfirm";
import MulMediaListBox from "@common/mulMediaListBox/materialListBox";
import ConfirmDy from "@common/confirmDy/confirm";
import equipCheck from "@common/equipCheck/index";
import equipInfo from "@common/equipInfo/index";
import equipOut from "@common/equipOut/index";
import auditProcess from "@common/auditProcess/index";
import auditDialog from "@common/auditDialog/index";
import adminauditProcess from "@common/adminAuditProcess/index";
import adminauditDialog from "@common/adminAuditDialog/index";
import backendFilterBox from "@common/backendFilter/index";
import aiMaterial from "@common/aiMaterial/aiMaterial";
import VoiceComposeSelectDialog from "@common/voiceComposeSelectDialog/voiceComposeSelectDialog";
import dutyInfo from "@common/dutyInfo/dutyInfo";
import foremanInfo from "@common/foremanInfo/foremanInfo";
import progressUpdate from "@common/progressUpdate/progressUpdate";
import discussBox from "@common/discussBox/discussBox";
import PreviewBili from "@common/previewBili/previewBox";

import "whatwg-fetch";
import {
  Progress,
  DatePicker,
  TimeSelect,
  TimePicker,
  Select,
  Option,
  Button,
  Input,
  Tooltip,
} from "element-ui";
import axios from "axios";
import "element-ui/lib/theme-chalk/index.css";
const appNotificationHandler = new AppNotificationHandler();
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(componentsInstall);
Vue.component(Progress.name, Progress);
Vue.component(DatePicker.name, DatePicker);
Vue.component(TimeSelect.name, TimeSelect);
Vue.component(TimePicker.name, TimePicker);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Tooltip.name, Tooltip);
Vue.prototype.$appNotificationHandler = appNotificationHandler;
Vue.prototype.$toast = Toast;
Vue.prototype.$toastConfirm = ToastConfirm;
Vue.prototype.$confirm = Confirm;
Vue.prototype.$confirmTitle = ConfirmTitle;
Vue.prototype.$fullTitle = FullTitle;
Vue.prototype.$loading = Loading;
Vue.prototype.$imgLoading = ImgLoading;
Vue.prototype.$ask = Ask;
// Vue.prototype.$materialBox = MaterialBox;
Vue.prototype.$materialBox = NewMaterialBox;
Vue.prototype.$materialListBox = MaterialListBox;
Vue.prototype.$audit = Audit;
Vue.prototype.$viewer = Viewer;
Vue.prototype.$pageType = Pagetype;
Vue.prototype.$voiceEditType = VoiceEditType;
Vue.prototype.$picEditType = PicEditType;
Vue.prototype.$picEditType1 = PicEditType1;
Vue.prototype.$success = Success;
Vue.prototype.$cloudEditConfirm = CloudEditConfirm;
Vue.prototype.$cloudEditConfirmStream = CloudEditConfirmStream;
Vue.prototype.$miniPicture = MiniPicture;
Vue.prototype.$typo = Typo;
Vue.prototype.$card = Card;
Vue.prototype.$cardPos = CardPos;
Vue.prototype.$cardRight = CardRight;
Vue.prototype.$DownloadBtn = DownloadBtn;
Vue.prototype.$warning = Warning;
Vue.prototype.$kkType = KkType;
Vue.prototype.$DownloadMessage = NewDownloadMessage;
Vue.prototype.$RadioDownloadMessage = RadioDownloadMessage;
Vue.prototype.$AudioDownloadMessage = AudioDownloadMessage;
Vue.prototype.$FileSend = FileSend;
Vue.prototype.$chatGpt = chatGpt;
Vue.prototype.$Rename = Rename;
Vue.prototype.$LabelSelect = LabelSelect;
Vue.prototype.$NewMaterialBox = NewMaterialBox;
Vue.prototype.$ShareCode = ShareCode;
Vue.prototype.$MediaPlatform = MediaPlatform;
Vue.prototype.$MediaPlatformShare = MediaPlatformShare;
Vue.prototype.$MediaPlatformNotify = MediaPlatformNotify;
Vue.prototype.$MediaPlatformNotifyAuth = MediaPlatformNotifyAuth;
Vue.prototype.$MediaPlatformManage = MediaPlatformManage;
Vue.prototype.$MediaPlatformAccount = MediaPlatformAccount;
Vue.prototype.$PreviewBox = PreviewBox;
Vue.prototype.$PreviewKnews = PreviewKnews;
Vue.prototype.$EditorCard = EditorCard;
Vue.prototype.$MediaListBox = MediaListBox;
Vue.prototype.$MediaPlatformPhoto = MediaPlatformPhoto;
Vue.prototype.$MediaPlatformTag = MediaPlatformTag;
Vue.prototype.$BPlus = BPlus;
Vue.prototype.$filterBox = filterBox;
Vue.prototype.$Dialog = Dialog;
Vue.prototype.$SelectDialog = SelectDialog;
Vue.prototype.$Table = Table;
Vue.prototype.$authTable = authTable;
Vue.prototype.$ArticlePreview = ArticlePreview;
Vue.prototype.$MediaPreview = MediaPreview;
Vue.prototype.$MediaSort = MediaSort;
Vue.prototype.$InterviewCheck = InterviewCheck;
Vue.prototype.$InterviewTable = InterviewTable;
Vue.prototype.$UploadTable = UploadTable;
Vue.prototype.$ResourcesDetail = ResourcesDetail;
Vue.prototype.$WaterEdit = WaterEdit;
Vue.prototype.$TagInput = TagInput;
Vue.prototype.$VideoClip = VideoClip;
Vue.prototype.$MediaPlatformWater = MediaPlatformWater;
Vue.prototype.$dyScan = dyScan;
Vue.prototype.$tipsBox = tipsBox;
Vue.prototype.$axios = axios;
Vue.prototype.$toastHtml = toastHtml;
Vue.prototype.$MulMediaListBox = MulMediaListBox;
Vue.prototype.$ConfirmDy = ConfirmDy;
Vue.prototype.$equipCheck = equipCheck;
Vue.prototype.$equipInfo = equipInfo;
Vue.prototype.$equipOut = equipOut;
Vue.prototype.$auditProcess = auditProcess;
Vue.prototype.$auditDialog = auditDialog;
Vue.prototype.$adminauditProcess = adminauditProcess;
Vue.prototype.$adminauditDialog = adminauditDialog;
Vue.prototype.$backendFilterBox = backendFilterBox;
Vue.prototype.$AiMessage = AiMessage;
Vue.prototype.$AiWriter = AiWriter;
Vue.prototype.$AiOptimizeWriter = AiOptimizeWriter;
Vue.prototype.$AiMaterial = aiMaterial;
Vue.prototype.$VoiceComposeSelectDialog = VoiceComposeSelectDialog;
Vue.prototype.$dutyInfo = dutyInfo;
Vue.prototype.$foremanInfo = foremanInfo;
Vue.prototype.$progressUpdate = progressUpdate;
Vue.prototype.$discussBox = discussBox;
Vue.prototype.$PreviewBili = PreviewBili;
Vue.prototype.$EventBus = new Vue();

function rewirteLog() {
  console.log = (function (log) {
    return process.env.NODE_ENV == "production" ? function () {} : log;
  })(console.log);
}

const routerConfig = new VueRouter({
  mode: "history",
  routes: routes.pages,
});

routerConfig.beforeEach((to, from, next) => {
  let path = to.path;
  const isLogin = common.checkLogin();
  let isShare = false;
  if (path.indexOf("/share") != -1) {
    isShare = true;
  }
  // console.log(path.split('/'))
  path = path.split("/");
  const truePath = "/" + path[1];
  common.closeMaterial();
  if (truePath !== "/tuozhanshebei") {
    store.commit("setResourceType", "backConfirm");
  }

  const goLogin =
    !isLogin &&
    truePath !== "/login" &&
    truePath !== "/admin" &&
    truePath !== "/share" &&
    truePath !== "/newmediashare" &&
    truePath !== "/dyPreviewBox" &&
    truePath !== "/backendFilter" &&
    truePath !== "/empower" && truePath !== "/previewLibrary";
  if (goLogin) {
    next({
      path: "/login",
    });
  } else {
    next();
  }
});

common
  .myFetch(apis.Site_title, { method: "post", needLogin: false, data: {} })
  .then((r) => {
    let title = "";
    if (r) {
      title = r.project_title;

      Vue.prototype.$_syscfg = {
        // 全局配置，用户替换系统中各项目名称和重命名后的模块名
        title: r.project_title || "",
        topic: r.topic || "",
        interview: r.interview || "",
        clue: r.material || "",
        report: r.report || "",
        resource: r.resource || "",
        evaluation: r.appraisal || "",
        data: r.kankan || "",
        proposal: r.proposal || "",
        publish: r.fabu || "",
        default_img: r.default_img || "",
        index_log: r.index_log || "",
        product_logo: r.product_logo || "",
        default_media: r.default_media || "",
        default_avatar: r.default_avatar || "",
      };
    }

    document.title = title;

    new Vue({
      router: routerConfig,
      store,
      render: (h) => h(App),
      el: "#app",
    });
  });

// rewirteLog()
